import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { AUTH_FEATURE_KEY } from './keys';
import { authReducer } from './reducers/auth.reducer';
import { AuthEffects } from './effects/auth.effects';

export function provideAuthStore(): EnvironmentProviders[] {
    return [provideState(AUTH_FEATURE_KEY, authReducer), provideEffects(AuthEffects)];
}
